import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-value-spec-chip"
  }, [_vm.showLabel && _vm.label ? _c('span', {
    staticClass: "mapper-value-spec-chip__label text--secondary"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), !_vm.value ? _c(VBtn, {
    staticClass: "mapper-value-spec-chip__add",
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": `${_vm.dataTest}-add`
    },
    on: {
      "click": function ($event) {
        _vm.$emit('input', _vm.createDraft());
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n    " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.valueSpec.setValue')) + "\n  ")], 1) : _c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      "max-width": "440",
      "min-width": "340",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VChip, _vm._g(_vm._b({
          staticClass: "mapper-value-spec-chip__chip",
          class: `mapper-value-spec-chip__chip--${_vm.summary.kind}`,
          attrs: {
            "disabled": _vm.disabled,
            "label": "",
            "outlined": "",
            "small": "",
            "data-test": `${_vm.dataTest}-chip`
          }
        }, 'v-chip', attrs, false), on), [_c(VIcon, {
          attrs: {
            "left": "",
            "size": "11"
          }
        }, [_vm._v(_vm._s(_vm.kindIcon))]), _c('span', {
          staticClass: "mapper-value-spec-chip__text"
        }, [_vm._v(_vm._s(_vm.summary.text))]), _vm.summary.transformCount ? _c('span', {
          staticClass: "mapper-value-spec-chip__transforms",
          attrs: {
            "title": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.transforms')
          }
        }, [_vm._v("\n          · " + _vm._s(_vm.summary.transformCount) + "\n        ")]) : _vm._e()], 1)];
      }
    }])
  }, [_c(VCard, [_c(VCardTitle, {
    staticClass: "mapper-value-spec-chip__title"
  }, [_vm._v("\n        " + _vm._s(_vm.label || _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.editorTitle')) + "\n      ")]), _c(VCardText, [_c('mapper-value-spec-form', {
    attrs: {
      "value": _vm.value,
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "data-test": _vm.dataTest
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  })], 1), _vm.optional ? _c(VCardActions, [_c(VBtn, {
    attrs: {
      "disabled": _vm.disabled,
      "small": "",
      "text": "",
      "data-test": `${_vm.dataTest}-clear`
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', null);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "left": "",
      "size": "12"
    }
  }, [_vm._v("fal fa-trash-alt")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.valueSpec.clearValue')) + "\n        ")], 1)], 1) : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };